var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[(_vm.state)?_c('div',{staticClass:"youthIntro"},[_c('img',{attrs:{"src":require("@/assets/img/youth_intro_2024.jpg"),"alt":""}})]):_c('div',{staticClass:"youthIntro"},[_c('img',{attrs:{"src":require("@/assets/img/bg_waiting_U.png"),"alt":""}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }